module.exports = __webpack_public_path__ + "img/网站-06.39c1c2cf.jpg";